/* @flow */

//----------------------------------------------------------------------//
// GLOBAL MODULES
//----------------------------------------------------------------------//

import * as React from 'react';
import Moment from 'react-moment';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// DATA
//----------------------------------------------------------------------//

import { dataTableFields } from './DataTableFields';

//----------------------------------------------------------------------//
// CSS
//----------------------------------------------------------------------//

import styles from './DataTable.module.scss';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

const DataTable: React.StatelessFunctionalComponent<*> = ({ data, template, t }: Object) => {
  if (Object.keys(data).length > 0) {
    return (
      <div className={styles['notification-table']}>
        <table>
          <tbody>
            {Object.keys(data).map((key: string, index: number) => {
              if (dataTableFields[key] && data[key]) {
                return (
                  <tr key={key}>
                    <td>
                      <b>{`${t(dataTableFields[key].label)}:`}</b>
                    </td>
                    <td>
                      {dataTableFields[key].type === 'date' ? (
                        <Moment date={data[key]} format="MMMM DD, YYYY" />
                      ) : dataTableFields[key].type === 'days' ? (
                        `${data[key]} days`
                      ) : dataTableFields[key].type === 'number' ? (
                        data[key].toLocaleString()
                      ) : dataTableFields[key].type === 'custom_date' ? (
                        <React.Fragment>
                          <span>
                            &nbsp;
                            <Moment
                              date={template.calibration_due_date}
                              diff={new Date()}
                              unit="days"
                            />{' '}
                            days
                          </span>
                          <span>
                            &nbsp;(
                            <Moment
                              date={template.calibration_due_date}
                              format="MMMM DD, YYYY - hh:mm A"
                            />
                            )
                          </span>
                        </React.Fragment>
                      ) : (
                        data[key]
                      )}
                    </td>
                  </tr>
                );
              }

              return null;
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return null;
};

export default translate()(DataTable);
